<template>
  <div class="Group">
    <div class="title">{{title}}</div>
    <div class="groups">
      <div v-for="(g, index) in groups" class="grp" @click="select(g.index)">
        <my_image class="img" :class="{selected: selected==g.index }" :src="g.img" :width="imgWidth"></my_image>
        <div class="text">{{g.text}}</div>
        <div class="extra">{{g.extra}}</div>
      </div>
    </div>
  </div>
</template>

<script>

  import MyImage from '@/components/Image.vue'

  export default {
    name: '',
    data() {
      return {
        selected: 1
      }
    },
    computed: {
      title() {
        return '参赛组别'
      },
      imgWidth() {
        return '8.75vw'
      },
      groups() {
        return this.$store.state.enroll.groups
      }
    },
    methods: {
      select(index) {
        this.selected = index
        this.$store.commit('updateEnrollGroup', index)
      },

    },
    mounted(){
      let userInfo = this.$parent.user
      if(userInfo.group){
        this.select(userInfo.group - 1)
      }
    },
    components: {
      my_image: MyImage
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .Group{
    width: 62.5vw;
    height: 25.26vw;
    box-sizing: border-box;
    padding-top: 2.4vw;
    padding-bottom: 2.1vw;
    background-image: url(~@/assets/image/enroll/bg-group.png);
    background-size: 62.5vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .title{
    color: white;
    font-size: 1.875vw;
    line-height: 1.85vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .groups{
    text-align: center;
    width: 55.36vw;
    height: 16.93vw;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .grp{
    cursor: pointer;
    color: white;
    display: flex;
    flex-direction: column;
    align-items:center;
  }

  .grp .img{
    border-radius: 50%;
    width: 8.75vw;
    background: white;
    border: 0.35vw solid transparent;
  }

  .grp .img.selected{
    border: 0.35vw solid #62DD95;
  }

  .grp .text{
    margin-top: 1.78vw;
    font-size: 1.25vw;
    font-weight: 400;
  }

  .grp .extra{
    font-size: 1.04vw;
    font-weight: 300;
  }
</style>
